/**
 * Error raised when trying to add element that is already present in a collection
 */
export class AddingDuplicateElementError extends Error {
    constructor() {
        super("Unable to add element as it is present already");
    }
}
